import { DATA_STORE_KEYS, DataStore } from '@providers/dataStore';
import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(
        DataStore.getItem(DATA_STORE_KEYS.IS_LOGGEDIN) === 'true',
    );
    const [user, setUser] = useState(null);

    const login = (user, employeeData) => {
        setIsAuthenticated(true);
        setUser({ ...user, ...employeeData });
    };

    const logout = () => {
        setIsAuthenticated(false);
        setUser(null);
        // Clear DataStore items
        DataStore.removeItem(DATA_STORE_KEYS.USER);
        DataStore.removeItem(DATA_STORE_KEYS.USER_EMPLOYEE);
        DataStore.removeItem(DATA_STORE_KEYS.IS_LOGGEDIN);
        DataStore.removeItem(DATA_STORE_KEYS.USER_DATA);
        DataStore.removeItem(DATA_STORE_KEYS.USER_CURRENT_ROLE);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
